<template lang="html">
  <div class="flex mh4 mv4">
    <div v-if="Boolean(school.district_id)" class="pl-title">
      NOTE: You cannot edit this school's membership because it is part of a
      district. To make teachers from this school paid users, you will need to
      create a membership at the district level
      <br />
      <pl-button @click.native="goToDistrict" class="pl-primary">
        Go to District</pl-button
      >
    </div>

    <div v-else>
      <div class="msm-title mb4 pt3">Manage school Memberships</div>
      <div class="mb4">
        <h2>Active Memberships</h2>
        <ul>
          <li class="pl-subheading" v-for="membership in active_memberships">
            <div class="row col-xs between-xs ma0">
              <span>
                <strong>Expiry Date</strong>:
                {{ membership.end_date_readable }}</span
              >
              <pl-menu :menuSize="5" direction="right">
                <pl-button
                  slot="menu_trigger"
                  class="pl-icon"
                  style="margin: 0px; min-height: 22px; font-size: 12px;"
                >
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </pl-button>
                <ul menu-content>
                  <li
                    @click="openDeleteMembershipDialog(membership.id)"
                    style="color: #e53935;"
                  >
                    Delete Membership
                    <i style="color: #e53935;" class="fas fa-trash-alt" />
                  </li>
                </ul>
              </pl-menu>
            </div>
            <strong>Date Started</strong>: {{ membership.start_date_readable }}
            <br />
            <strong>Membership Type</strong>: {{ membership.membership_type }}
            <br />
            <strong>Number of Licenses</strong>:
            {{ membership.number_of_licenses }}
          </li>
        </ul>
      </div>
      <div class="mb4">
        <h2>Previous (Expired) Memberships</h2>
        <ul>
          <li class="pl-subheading" v-for="membership in expired_memberships">
            <div class="row col-xs between-xs ma0">
              <span>
                <strong>Expiry Date</strong>:
                {{ membership.end_date_readable }}</span
              >
              <pl-menu :menuSize="5" direction="right">
                <pl-button
                  slot="menu_trigger"
                  class="pl-icon"
                  style="margin: 0px; min-height: 22px; font-size: 12px;"
                >
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </pl-button>
                <ul menu-content>
                  <li
                    @click="openDeleteMembershipDialog(membership.id)"
                    style="color: #e53935;"
                  >
                    Delete Membership
                    <i style="color: #e53935;" class="fas fa-trash-alt" />
                  </li>
                </ul>
              </pl-menu>
            </div>

            <strong>Date Started</strong>: {{ membership.start_date_readable }}
            <br />
            <strong>Membership Type</strong>: {{ membership.membership_type }}
            <br />
            <strong>Number of Licenses</strong>:
            {{ membership.number_of_licenses }}
          </li>
        </ul>
      </div>
      <div class="mb4">
        <h2>Create New Membership</h2>

        <!-- Membership Date Picker -->

        <div class="flex justify-start items-center ml1 mb2">
          <div class="title small">
            <span class="b"> Start date:</span>
          </div>
          <pl-input
            v-model="start_date"
            type="date"
            id="start"
            name="membership-selection"
            customStyle="small-input"
            required
          />
        </div>

        <div class="flex justify-start items-center ml1 mb2">
          <div class="title small">
            <span class="b"> End date:</span>
          </div>
          <pl-input
            v-model="end_date"
            type="date"
            id="end"
            name="membership-selection"
            customStyle="small-input"
            required
          />
        </div>
        <div class="flex justify-start items-center ml1 mb2">
          <div class="title large">
            <span class="b"> Membership Type:</span>
          </div>
          <pl-select
            :options="membership_types"
            :selected="'Per ' + membership_type_selected"
            @change="membership_type_selected = $event"
            class="membership-type-select no-padding"
            style="width: 170px;"
          >
          </pl-select>
        </div>
        <div class="flex justify-start items-center ml1 mb2">
          <div class="title large">
            <span class="b">Number of licenses: </span>
          </div>
          <pl-input
            v-model="number_of_licenses"
            type="number"
            placeholder="Enter Number"
            customStyle="small-input"
          />
        </div>

        <!-- Create New Membership Button -->
        <div class="mv2">
          <pl-button
            class="pl-primary"
            @click.native="createNewSchoolMembership"
          >
            Create New
          </pl-button>
        </div>
      </div>
    </div>
    <dialog-delete-confirm
      v-if="show_remove_membership_confirmation"
      @close="show_remove_membership_confirmation = false"
      @actionConfirmed="removeSchoolMembership"
      header="Are you sure you want to delete this membership"
    />
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';
  import moment from 'moment';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';

  export default {
    components: {
      dialogDeleteConfirm,
    },
    data() {
      return {
        memberships: [],
        start_date: '',
        membership_type_selected: null,
        membership_types: [],
        number_of_licenses: null,
        end_date: '',
        show_remove_membership_confirmation: false,
        membership_id_to_remove: '',
      };
    },
    computed: {
      ...mapGetters(['getCurrentSchool']),
      expired_memberships() {
        return this.memberships.filter((membership) => {
          // Return true if right now (`moment()`) is after the end date of the membership
          return moment().isAfter(membership.end_date);
        });
      },
      active_memberships() {
        return this.memberships.filter((membership) => {
          // Return true if right now (`moment()`) is before the end date of the membership
          return moment().isBefore(membership.end_date);
        });
      },
      school() {
        return this.getCurrentSchool;
      },
    },
    methods: {
      goToDistrict() {
        const { district_id } = this.school;
        this.$router.push(`/admin-view-individual-district/${district_id}`);
      },
      createNewSchoolMembership() {
        const has_confirmed = confirm(
          'Are you sure you want to create a new school membership? All teachers that belong to this school will have their memberships extended to the End Date you have selected'
        );
        if (has_confirmed) {
          const payload = {
            school_id: this.$route.params.schoolID,
            end_date: this.end_date,
            start_date: this.start_date,
            membership_type: this.membership_type_selected,
            number_of_licenses: this.number_of_licenses,
          };
          adminServices
            .createSchoolMembership(payload)
            .then((res) => {
              this.memberships.push(res.data);
              this.end_date = '';
              this.start_date = '';
              this.number_of_licenses = null;
              this.membership_type_selected = this.membership_types[0];
              this.$store.dispatch(
                'getSchoolDetails',
                this.$route.params.schoolID
              );
              EventBus.$emit('toast-msg', 'success');
            })
            .catch((err) => {
              EventBus.$emit('alert-msg', err.response.data.message);
            });
        }
      },
      openDeleteMembershipDialog(membershipID) {
        this.membership_id_to_remove = membershipID;
        this.show_remove_membership_confirmation = true;
      },
      removeSchoolMembership() {
        adminServices
          .deleteSchoolMembership(this.membership_id_to_remove)
          .then(() => {
            const index = this.memberships.findIndex(
              (el) => el.id === this.membership_id_to_remove
            );
            this.memberships.splice(index, 1);
          })
          .catch(console.log);
      },
    },
    mounted() {
      const { schoolID } = this.$route.params;

      adminServices
        .getSchoolMemberships(schoolID)
        .then((res) => (this.memberships = res.data))
        .catch((err) => console.error(err));

      adminServices
        .getSchoolMembershipTypes()
        .then((res) => {
          this.membership_types = res.data;
          this.membership_type_selected = res.data[0];
        })
        .catch((err) => console.error(err));
    },
  };
</script>

<style lang="stylus" scoped>
  .msm-title
    height: 39px
    font-size: 32px
    color: #595959
    font-weight: 600
  .title
    padding:5px
  .large
    min-width: 165px
  .small
    width:125px
  .membership-type-select
    height: 30px
    text-transform: capitalize
    border: 2px solid #e1e8ee
    border-radius: 10px
  button.pl-icon
    height: 22px
    width: 22px
    min-width: 22px
</style>



// WEBPACK FOOTER //
// adminMemberships.vue?0d80ef19